import { SimulationParameterType } from '@nexelem/graphne-api';
import { BooleanParameter } from './BooleanParameter';
import { DateParameter } from './DateParameter';
import { RangeParameter } from './RangeParameter';
import { TextParameter } from './TextParameter';

type ParameterFieldProps = {
  name: string;
  label: string;
  parameterType: SimulationParameterType;
  from?: number | null;
  to?: number | null;
  required: boolean;
};

export const ParameterField = ({ name, label, parameterType, from, to, required }: ParameterFieldProps) => {
  const common = { name, label };

  if (parameterType === SimulationParameterType.Boolean) {
    return <BooleanParameter {...common} />;
  }

  if (parameterType === SimulationParameterType.Date) {
    return <DateParameter {...common} required={required} />;
  }

  if (from != null && to != null) {
    return <RangeParameter {...common} from={from} to={to} />;
  }

  return <TextParameter {...common} numeric={parameterType === SimulationParameterType.Int} required={required} />;
};
